<template>
  <slot v-bind="{ saveForm, closeForm, deleteFile, restoreFile, loadingSave, loadingDelete }"></slot>
</template>

<script>
import { FileApi, DocumentApi } from '../../test-api/index.ts'
import bcFileStore from '@/frontapp/store/bcFile'
import bcSelectedStore from '@/frontapp/store/bcSelected'
import DocumentStore from '@/frontapp/mixins/DocumentStore'
import { mapStores } from 'pinia'
import Toast from '@/frontapp/mixins/actions/Toast'
import deleteFiles from '../../mixins/actions/DeleteFiles'
import restoreFiles from '../../mixins/actions/RestoreFiles'
import handleApiError from '../../utils/handleApiError'
import UpdateDocumentRevision from '@/frontapp/mixins/actions/UpdateDocumentRevision'

const fileApi = new FileApi({}, '/api/v2')
const documentApi = new DocumentApi({}, '/api/v2')

export default {
  mixins: [DocumentStore],
  data() {
    return {
      loadingSave: false,
      loadingDelete: false,
    }
  },
  computed: {
    ...mapStores(bcFileStore, bcSelectedStore)
  },
  methods: {
    async save() {
      const dto = {
        name: this.$formValues['frm-editFileForm-editFileForm-name'],
        tags: this.$formValues['frm-editFileForm-editFileForm-tags'],
        replace__file_id: this.$formValues['frm-editFileForm-editFileForm-replace__file_id'],
      }
      
      if (this.$route.matched[0].name !== 'BCDocument') {
        const response = await handleApiError(() => fileApi.fileUpdate(
          this.$formValues['frm-editFileForm-editFileForm-id'],
          dto
        ))

        this.bcFileStore.updateFile(response.data)
        return
      }

      const response = await handleApiError(() => documentApi.documentUpdateFile(
        this.bcDocumentStore.document.id,
        this.bcDocumentStore.document.bc_document_rev_id,
        this.$formValues['frm-editFileForm-editFileForm-id'],
        dto
      ))

      if (response.data.bc_document_rev_id !== this.bcDocumentStore.documentRev) {
        this.bcDocumentStore.setWillChangeRevision(response.data)
        await UpdateDocumentRevision(this.bcDocumentStore, response.data.bc_document_rev_id, this.$router)
      
      } else {
        this.bcDocumentStore.setDocument(response.data)
      }
    },
    async delete(fileId) {
      this.loadingDelete = true
      await deleteFiles([fileId])
      this.loadingDelete = false
    },
    async restore(fileId) {
      this.loadingDelete = true
      await restoreFiles([fileId])
      this.loadingDelete = false
    },
    saveForm(close) {
      this.loadingSave = true
      this.save().then(() => {
        this.bcSelectedStore.reload()
        close()
        Toast(
          'success',
          this.$t('Changes were saved')
        )
        this.loadingSave = false
      })
      return false
    },
    closeForm() {
      if (this.$route.matched[0].name !== 'BCDocument') {
        this.$router.replace(this.$route.matched[0].name === 'BCFile' ? '/file' : '/trash-file');
      }

      this.$formValues['frm-editFileForm-editFileForm-name:change'] = ''
      this.$formValues['frm-editFileForm-editFileForm-tags:change'] = []
      this.$controls['frm-editFileForm-editFileForm-replace__file_id'].file = null
      this.$formValues['frm-editFileForm-editFileForm-replace__file_id:change'] = null

      this.$store.commit('nette/updateControl', {
        controlName: 'editFileForm',
        data: null,
        key: 'detail',
      })
    },
    deleteFile(close) {
      this.delete(this.$formValues['frm-editFileForm-editFileForm-id']).then(() => {
        this.bcSelectedStore.resetSelected()
        close()
      })
      return false
    },
    restoreFile(close) {
      this.restore(this.$formValues['frm-editFileForm-editFileForm-id']).then(() => {
        this.bcSelectedStore.resetSelected()
        close()
      })
      return false
    }
  }
}
</script>

<style lang="scss"></style>
